import Reconciliation from './index';

export default { path: '/home/reconciliation', component: Reconciliation };
